<template>
	<div class="container">
		<h1 class="wiki-h1">Главная</h1>
		<div class="welcome">
			<div class="welcome-wrapper">
				<h2 class="welcome-title">Добро пожаловать в WIKI <br><span>BLACK</span> RUSSIA</h2>
				<n-space class="welcome-links" >
					<n-button v-for="(val, key) in state.siteLinks"
						:key="key"
						tag="a"
						:href="val.href"
						round
						secondary
						type="info"
						class="welcome-wrapper-item">
						<template #icon>
							<n-icon :component="val.icon"/>
						</template>
						{{ val.title }}
					</n-button>
				</n-space>
				<n-space class="welcome-links" >
					<n-button tag="a"
						href="https://blackrussia.online/"
						round
						class="welcome-wrapper-item">
						Официальный сайт
					</n-button>
					<n-button tag="a"
						href="https://forum.blackrussia.online/"
						round
						class="welcome-wrapper-item">
						Форум
					</n-button>
					<n-button tag="a"
						href="https://vk.com/blackrussia.online"
						round
						class="welcome-wrapper-item">
						Группа ВК
					</n-button>
				</n-space>
				
			</div>

		</div>
	</div>
</template>

<script setup>
import { h, reactive } from "vue"
import { Balloon, Car, People } from "@vicons/ionicons5"
import { NIcon } from "naive-ui"

const renderIcon = (icon) => {
	return () => h(NIcon, null, { default: () => h(icon) })
}

const state = reactive({
	siteLinks: [
		{
			title: "Скины",
			href: "/general/skins",
			icon: renderIcon(People)
		},
		{
			title: "Автомобили",
			href: "/general/cars",
			icon: renderIcon(Car)
		},
		{
			title: "Аксессуары",
			href: "/general/accessories",
			icon: renderIcon(Balloon)
		}
	]
})
</script>

<style scoped lang="scss">
.welcome {
  display: flex;
  flex-direction: column;

  flex: 1 1 auto;
  margin: 50px 0;
  &-wrapper {
    width: 520px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &-title {
    font-size: 42px;
    font-weight: 500;
    span {
      color: #e4360d
    }
  }
  &-links {
    justify-content: flex-start!important;
  }
}

@media (max-width: 768px) {
  .welcome {
    &-wrapper {
      width: auto;
    }
    &-title {
      font-size: 24px;
      font-weight: 500;

    }
    &-links {
      flex-direction: column!important;
      a {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}

</style>